module.exports = __webpack_public_path__ + "img/xionglei.adb18f4f.png";